import ForWhomForm from '@/modules/life/rater/views/forms/ForWhomForm.vue'
import InsuranceTypeForm from '@/modules/life/rater/views/forms/InsuranceTypeForm.vue'
import StartDateForm from '@/modules/common/rater/views/forms/StartDateForm.vue'
import BirthDateForm from '@/modules/life/rater/views/forms/BirthDateForm.vue'
import InsuredCapitalForm from '@/modules/life/rater/views/forms/InsuredCapitalForm.vue'
import CoveragesForm from '@/modules/life/rater/views/forms/CoveragesForm.vue'
import type FormPage from '@/modules/common/common/models/APP/FormPage'

export default {
  ForWhom: {
    form: ForWhomForm,
    next: ['InsuranceTypeForm']
  },
  InsuranceTypeForm: {
    form: InsuranceTypeForm,
    next: ['StartDateForm']
  },
  StartDateForm: {
    form: StartDateForm,
    next: ['BirthDateForm']
  },
  BirthDateForm: {
    form: BirthDateForm,
    next: ['InsuredCapitalForm']
  },
  InsuredCapitalForm: {
    form: InsuredCapitalForm,
    next: ['CoveragesForm']
  },
  CoveragesForm: {
    form: CoveragesForm,
    next: []
  }
} as Record<string, FormPage>
